<template lang="pug">
  b-modal#approveTicket(
    ref="approveTicket"
    :title='$t("ui.combine.approve_ticket")'
    centered
    no-fade
    no-close-on-backdrop
    :busy="loading"
    @ok="done"
    @show="reset"
    @shown="shown")
    template(v-if="ticketDetail")
      .clusterize-scroll.table-responsive
        table.table.table-sm.table-bordered.table-striped.table-hover
          thead.thead-light
            tr
              th(width="35%")
                span  {{ ticketDetail.request_type }}
              th(width="65%")
                span &nbsp;
          tbody.clusterize-content
            tr
              td
                span {{ $t("ui.id") }}
              td
                span {{ ticketDetail.id }}
            tr
              td
                span {{ $t("ui.member") }}
              td
                span {{ ticketDetail.member_id }}
            tr
              td
                span {{ $t("ui.domain") }}
              td
                span {{ ticketDetail.domain_name }}
            tr
              td
                span {{ $t("ui.amount") }}
              td
                span.font-weight-bold(:class="$helpers.fontClassName(ticketDetail.amount)") {{ $n(ticketDetail.amount, 'currency') }}
                //- span.text-danger(v-if="ticketDetail.exchanged_amount") {{ (ticketDetail.deposit_method.toUpperCase() == 'USDT'? "(" + $n(ticketDetail.exchanged_amount, 'currency') + ")" : "" )}}
            tr
              td
                span {{ $tc("ui.banks", 1) }}
              td
                span {{ ticketDetail.target_bank_id }}
            //- tr
            //-   td
            //-     span {{ $t("ui.bank_owner") }}
            //-   td
            //-     span {{ ticketDetail.target_bank_owner }}
            tr
              td
                span {{ $t("ui.bank_acc_no") }}
              td
                span {{ ticketDetail.target_bank_acc_no }}
            tr
              td
                span {{ $t("ui.bank_acc_holder") }}
              td
                span {{ ticketDetail.target_bank_acc_holder }}
            tr(v-if="['ARS','AUD'].includes(getCurrencyCode)")
              td
                span {{ ['AUD'].includes(getCurrencyCode) ? $t("ui.bsb") : $t("ui.cuit") }}
              td
                span {{ ticketDetail.target_bank_acc_remark }}
            tr(v-if="['AUD'].includes(getCurrencyCode)")
              td
                span {{ $t("ui.payid") }}
              td
                span {{ ticketDetail.target_bank_acc_remark_2 }}
            //- tr
            //-   td
            //-     span {{ $t("ui.ref_no") }}
            //-   td
            //-     span {{ ticketDetail.ref_no }}
            tr(v-if="ticketDetail.request_type.toUpperCase() == 'DEPOSIT'")
              td
                span {{ $t("ui.deposit_date") }}
              td
                span(v-if="ticketDetail.deposit_date") {{ $moment(ticketDetail.deposit_date).format("YYYY-MM-DD, HH:mm:ss") }}
            tr(v-if="ticketDetail.request_type.toUpperCase() == 'DEPOSIT'")
              td
                span {{ $t("ui.deposit_method") }}
              td
                span {{ ticketDetail.deposit_method }}
            tr(v-if="ticketDetail.request_type.toUpperCase() == 'DEPOSIT'")
              td
                span {{ $t("ui.promo") }}
              td
                span {{ ticketDetail.promotion_id }}
            //- tr(v-if="ticketDetail.deposit_method == 'USDT'")
            //-   td
            //-     span {{ $t("ui.rate") }}
            //-   td
            //-     span {{ ticketDetail.rate }}
            //- tr(v-if="ticketDetail.deposit_method == 'USDT'")
            //-   td
            //-     span {{ $t("ui.rate_php") }}
            //-   td
            //-     span {{ ticketDetail.rate_php }}
            tr
              td
                span {{ $t("ui.status") }}
              td
                span(:class="$helpers.ticketStatusWoBadgeClass(ticketDetail.status)") {{ ticketDetail.status.trim().toUpperCase() }}
            template(v-if="ticketDetail.exchange_currency != null")
              tr
                td
                  span {{ $t("ui.base_rate") }} ({{ getCurrencyCode }})
                td
                  span.font-weight-bold(:title="$n(ticketDetail.base_rate, 'currency')" :class="$helpers.fontClassName(ticketDetail.base_rate)") {{ $n(ticketDetail.base_rate, 'currency') }}
              tr
                td
                  span {{ $t("ui.exchange_rate") }} ({{ ticketDetail.exchange_currency }})
                td
                  span.font-weight-bold(:title="$n(ticketDetail.exchange_rate, 'currency')" :class="$helpers.fontClassName(ticketDetail.exchange_rate)") {{ $n(ticketDetail.exchange_rate, 'currency') }}
              tr
                td
                  span {{ $t("ui.exchanged_amount") }}
                td
                  span.font-weight-bold(:title="ticketDetail.exchanged_amount" :class="$helpers.fontClassName(ticketDetail.exchanged_amount)") {{ ticketDetail.exchanged_amount }}
          
            tr(v-if="ticketDetail.status.trim().toUpperCase() != 'PENDING'")
              td
                span {{ $t("ui.remark") }}
              td
                span {{ ticketDetail.remark }}
            tr(v-if="ticketDetail.status.trim().toUpperCase() != 'PENDING'")
              td
                span {{ $t("ui.modified_by") }}
              td
                span {{ ticketDetail.modified_by }}
            tr(v-if="ticketDetail.status.trim().toUpperCase() != 'PENDING'")
              td
                span {{ $t("ui.modified_date") }}
              td
                span {{ $moment(ticketDetail.modified_date).format("YYYY-MM-DD, HH:mm:ss") }}
            tr
              td
                span {{ $t("ui.created_date") }}
              td
                span {{ $moment(ticketDetail.created_date).format("YYYY-MM-DD, HH:mm:ss") }}
      b-form-group(:label="$t('ui.sender_bank')" v-if="ticketDetail.request_type.toUpperCase() == 'WITHDRAWAL'").mb-0
        BankListAutoWithdrawal(
          ref="senderBank"
          size="sm"
          type="array"
          :dirty="$v.sender_bank.$dirty"
          :error="$v.sender_bank.$error"
          v-model.trim.lazy="$v.sender_bank.$model"
          :disabled="loading"
          :operatorID="parentId"
          :externalID="ticketDetail.external_id"
          @min-limit-updated="handleMinLimitUpdated"
          @min-limit-changed="handleMinLimitChanged"
        )
        ValidateResult(:value="$v.sender_bank" :name="$t('ui.sender_bank')")
        //- small.text-muted {{ sender_bank }}
        small.text-info.ml-2(v-if="minLimit != null") {{ $t("ui.min_withdrawal") }}: {{ minLimit }}
      b-form-group(:label="$t('ui.remark')" v-if="ticketDetail.status.trim().toUpperCase() != 'REJECTED'").mb-0
        DebounceInput(
          size="sm"
          type="text"
          v-model="remark"
          :disabled="loading"
        )
      div(slot="modal-footer")
        SubmitButton.float-right(icon="fa fa-check" :text="$t('ui.approve')" @click="approveTicket()" size="sm" variant="success" v-if="showApproveBtn()" :loading="loading")
        //- SubmitButton.float-right(icon="fa fa-ban" :text="$t('ui.reject')" @click="rejectTicket()" size="sm" variant="danger" v-if="ticketDetail.status == 1").mr-1
        SubmitButton.float-right(icon="far fa-times-circle" :text="$t('ui.close')" @click="closeModal()" size="sm" variant="primary" :loading="loading").mr-1
</template>

<script>
import { required, minLength, maxLength, url, requiredIf } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import DebounceInput from "@/library/DebounceInput";
import BankListAutoWithdrawal from "@/library/BankListAutoWithdrawal";
import ValidateResult from "@/library/ValidateResult";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    BankListAutoWithdrawal,
    ValidateResult
  },
  props: {
    ticketId:{
      type: Number,
      default: 0
    },
    parentId:{
      type: String,
      default: ""
    },
    memberId:{
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      ticketDetail: null,
      memberDetail: null,
      sender_bank: '',
      remark: '',
      minLimit: null,
      feedback: {
        success: true,
        status: ""
      },
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    }
  },
  mounted: function() {
  },
  validations: {
    sender_bank: {
      required : requiredIf(function () {
        return this.ticketDetail.request_type.toUpperCase() == 'WITHDRAWAL';
      }),
    },
  },
  methods: {
    showApproveBtn() {
      if (this.ticketDetail.request_type.toUpperCase() == 'DEPOSIT' && this.ticketDetail.status.trim().toUpperCase() == 'PENDING')
        return true;
      // else if (this.ticketDetail.request_type.toUpperCase() == 'WITHDRAWAL' && this.ticketDetail.status.trim().toUpperCase() == 'REVIEW')
      //   return true;
      else if (this.ticketDetail.request_type.toUpperCase() == 'WITHDRAWAL' && this.ticketDetail.status.trim().toUpperCase() == 'AUDIT')
        return true;
      else
        return false;
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.sender_bank = '';
      this.remark = '';
      this.minLimit = null;
      this.getTicketDetail();
    },
    getTicketDetail: function() {
      let url = config.ticketDetailUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        ticket_id: this.ticketId,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.ticketDetail = response.data.dt.length > 0 ? response.data.dt[0] : null;
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    approveTicket: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        // Check if exchanged_amount is less than minLimit
        if (this.ticketDetail && this.ticketDetail.exchange_currency != null && 
            this.ticketDetail.exchanged_amount != null && this.minLimit != null) {
          const exchangedAmount = parseFloat(this.ticketDetail.exchanged_amount);
          const minLimitValue = parseFloat(this.minLimit);
          
          if (!isNaN(exchangedAmount) && !isNaN(minLimitValue) && exchangedAmount < minLimitValue) {
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.minWithdrawalNotMet"), "error");
            return;
          }
        }
        this.confirmApproveTicket();
      }
    },
    confirmApproveTicket: function() {
      let url = '';
      if (this.ticketDetail.request_type.toUpperCase() == 'WITHDRAWAL') {
        url = config.ticketApproveWithdrawalUrl();
        var payment_mode = this.sender_bank.split(' - ')[1].trim();

        if (["LUXEPAYQR","FPAYQR","AMOPAY","DGPAYQR","SECRETPAYQRMY","MPIN","VADERPAYQR","PEPAYPIN","GSPAYQR"].includes(payment_mode)) {
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.notSupportedWithdrawalPG"), "error");
          return;
        }

        switch(payment_mode) {
          //argentina
          case "MGMPAY":
            url = config.withdrawalMGMPayUrl();
            break;
          case "ROCKETX":
            url = config.withdrawalROCKETXArsUrl();
            break;
          //russia
          case "INPAY":
            url = config.withdrawalINPayUrl();
            break;
          //argentina && russia
          case "HIGHHELP":
            if (this.getCurrencyCode == "ARS") {
              url = config.withdrawalHIGHHELPArsUrl();
            } else if (this.getCurrencyCode == "RUB") {
              url = config.withdrawalHIGHHELPRubUrl();
            }
            break;
          case "MERCURIO":
            if (this.getCurrencyCode == "ARS") {
              url = config.withdrawalMERCURIOArsUrl();
            } else if (this.getCurrencyCode == "RUB") {
              url = config.withdrawalMERCURIORubUrl();
            }
            break;
          case "JUPITER":
            if (this.getCurrencyCode == "ARS") {
              url = config.withdrawalJUPITERArsUrl();
            } else if (this.getCurrencyCode == "RUB") {
              url = config.withdrawalJUPITERRubUrl();
            }
            break;
          case "PROPAYLLER":
            if (this.getCurrencyCode == "RUB") {
              url = config.withdrawalPROPAYLLERRubUrl();
            }
            break;
          case "AMPAY":
            if (this.getCurrencyCode == "ARS") {
              url = config.withdrawalAMPayArsUrl();
            } else if (this.getCurrencyCode == "RUB") {
              url = config.withdrawalAMPayRubUrl();
            }
            break;
          case "ONEPAY":
            url = config.withdrawalONEPayUrl();
            break;
          case "NIRVANA":
            if (this.getCurrencyCode == "ARS") {
              url = config.withdrawalNIRVANAArsUrl();
            } else if (this.getCurrencyCode == "RUB") {
              url = config.withdrawalNIRVANARubUrl();
            } else if (this.getCurrencyCode == "AUD") {
              url = config.withdrawalNIRVANARubUrl();
            }
            break;
          //malaysia
          case "LUXEPAY":
            url = config.withdrawalLUXEPayUrl();
            break;
          case "FPAY":
            url = config.withdrawalFPayUrl();
            break;
          case "DGPAY":
            url = config.withdrawalDGPayUrl();
            break;
          case "TRUEPAY":
            url = config.withdrawalTRUEPayUrl();
            break;
          case "ONEPAYMY":
            url = config.withdrawalONEPayMYUrl();
            break;
          case "TRUSTPAY":
            url = config.withdrawalTRUSTPayUrl();
            break;
          case "EPICPAY":
            url = config.withdrawalEPICPayUrl();
            break;
          case "SECUREPAY":
            url = config.withdrawalSECUREPayUrl();
            break;
          case "JPAY":
            url = config.withdrawalJPayUrl();
            break;
          case "TTPAY":
            url = config.withdrawalTTPayUrl();
            break;
          case "AUTOPAY":
            url = config.withdrawalAUTOPayUrl();
            break;
          case "SECRETPAYMY":
            url = config.withdrawalSECRETPayMYUrl();
            break;
          case "METAPAY":
            url = config.withdrawalMETAPayUrl();
            break;
          case "VPAY":
            url = config.withdrawalVPayUrl();
            break;
          case "VADERPAY":
            url = config.withdrawalVADERPayUrl();
            break;
          case "GSPAY":
            url = config.withdrawalGSPayUrl();
            break;
          case "PEPAY":
            url = config.withdrawalPEPayUrl();
            break;
          case "NOVAPAY":
            url = config.withdrawalNOVAPayUrl();
            break;
          case "DIREPAY":
            url = config.withdrawalDIREPayUrl();
            break;
          //vietnam
          case "YESPAY":
            url = config.withdrawalYESPayUrl();
            break;
          case "BESTPAY":
            url = config.withdrawalBESTPayUrl();
            break;
          case "TIMEPAY":
            url = config.withdrawalTIMEPayUrl();
            break;
          case "DAYANGPAY":
            url = config.withdrawalDAYANGPayUrl();
            break;
          case "ONEVNPAY":
            url = config.withdrawalONEVNPayUrl();
            break;
          case "CLUBSPAY":
            url = config.withdrawalCLUBSPayUrl();
            break;
          case "SECRETPAY":
            url = config.withdrawalSECRETPayUrl();
            break;
          case "WOWPAY":
            url = config.withdrawalWOWPayUrl();
            break;
          case "UBIT":
            url = config.withdrawalUBITUrl();
            break;
          case "GLOBALPAY":
            url = config.withdrawalGLOBALPayUrl();
            break;
          case "BCATPAYVN":
            url = config.withdrawalBCATPayVNUrl();
            break;
          case "SOLIDPAY":
            url = config.withdrawalSOLIDPayUrl();
            break;
          case "KPAYVN":
            url = config.withdrawalKPayVNUrl();
            break;
          //bangladesh
          case "TIGERPAY":
            url = config.withdrawalTIGERPayUrl();
            break;
          case "TAKAPAY":
            url = config.withdrawalTAKAPayUrl();
            break;
          case "BCATPAY":
            url = config.withdrawalBCATPayUrl();
            break;
        }
      }
      else if (this.ticketDetail.request_type.toUpperCase() == 'DEPOSIT')
        url = config.ticketApproveDepositUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        ticket_id: this.ticketDetail.id,
        remark: this.remark,
      };

      if(this.ticketDetail.request_type.toUpperCase() == 'WITHDRAWAL') {
        json.target_bank_id = this.ticketDetail.target_bank_id;
        json.ref_no = this.ticketDetail.ref_no;
        // json.sender_bank_id = this.sender_bank.split(' - ')[0].trim(); //gateway
        json.payment_mode = this.sender_bank.split(' - ')[1].trim(); //mgmpay
        json.amount = this.ticketDetail.amount;
        json.target_bank_acc_holder = this.ticketDetail.target_bank_acc_holder;
      }

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$refs.approveTicket.hide();
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    closeModal: function() {
      this.$v.$reset();
      this.$refs.approveTicket.hide();
    },
    handleMinLimitUpdated: function(data) {
      // Store min_limit when balance data is received
      if (this.sender_bank && this.sender_bank.includes(' - ')) {
        var payment_mode = this.sender_bank.split(' - ')[1].trim();
        if (payment_mode === data.pg) {
          this.minLimit = data.min_limit;
        }
      }
    },
    handleMinLimitChanged: function(data) {
      // Update min_limit when selection changes
      this.minLimit = data.min_limit;
    },
  }
};
</script>
